<template>
  <div id="tagList" class="page-notbreadcrumb">
    <section class="page-list">
      <div class="title">
        <div class="title_l">
          <span class="tit">便企导航</span>
        </div>
        <div class="title_r">
          <el-popover
            popper-class="menu-popper"
            placement="bottom"
            width="170"
            height="105"
            trigger="hover"
            :visible-arrow="false"
            v-model="visible"
          >
            <div class="node-act">
              <div @click="classification(1)">
                <!-- <i class="iconfont iconwenjianjia1" /> -->
                <span>添加区域分类</span>
              </div>
              <div @click="classification(0)">
                <!-- <i class="iconfont iconbiaoqian" /> -->
                <span>添加机关政府</span>
              </div>
            </div>
            <i
              slot="reference"
              class="el-icon-circle-plus-outline add-icon"
            ></i>
          </el-popover>
        </div>
      </div>
      <div class="list_box">
        <div class="list_search">
          <el-input
            v-model="name"
            placeholder="搜索机关政府"
            clearable
            @input="getList()"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="getList()"
            />
          </el-input>
        </div>
        <div
          v-if="tagShow"
          style="font-size: 14px;color:#606266;border:1px solid #46a6ff;
          border-radius: 4px;padding:5px 10px;
          margin-top:15px;
          background-color: rgba(230, 247, 255, 1);
          display:flex"
        >
          <div>可拖拽部门进行排序，仅支持同层级的部门排序</div>
          <i
            class="el-icon-close"
            style="font-size:16px;cursor: pointer"
            @click="tagShow = false"
          ></i>
        </div>
        <div class="list_main">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            accordion
            :highlight-current="true"
            :default-expand-all="true"
            class="tag-tree"
            draggable
            @node-drop="handleDragEnd"
            :allow-drop="allowDrop"
          >
            <div
              @click="navigation(data)"
              class="node-item"
              slot-scope="{ node, data }"
              style="width: 85%; overflow: hidden"
            >
              <div class="subtitle" style="float: left">
                <i
                  v-if="data.depType === 1"
                  class="el-icon-location-information"
                  style="margin-right:10px;"
                ></i>
                <i
                  v-else
                  class="el-icon-price-tag"
                  style="margin-right:10px;"
                ></i>
                <span class="overFlowHid1" :title="node.label">{{
                  node.label
                }}</span>
              </div>
              <div class="more" style="float: right">
                <el-popover
                  placement="bottom"
                  width="153"
                  height="105"
                  trigger="hover"
                  popper-class="menu-popper"
                  :visible-arrow="false"
                  v-model="data.visible"
                >
                  <!-- 二级文件夹 -->
                  <div v-if="data.parentId !== 0" class="node-act">
                    <div class="more-item" @click="editRegion(data)">
                      编辑
                    </div>
                    <div class="more-item" @click="delFolder(data)">
                      删除
                    </div>
                  </div>
                  <!-- 一级文件夹 -->
                  <div v-if="data.parentId === 0" class="node-act">
                    <div
                      v-if="data.depType === 1"
                      class="more-item"
                      @click="addOffice(data)"
                    >
                      添加机关政府
                    </div>
                    <div class="more-item" @click="editRegion(data)">
                      编辑
                    </div>
                    <div class="more-item" @click="delFolder(data)">
                      删除
                    </div>
                  </div>
                  <i
                    slot="reference"
                    class="iconfont iconduogongneng"
                    @click.stop
                  />
                </el-popover>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </section>
    <section class="page-prop">
      <div class="page-headers" v-if="isCompontes">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="first">
            <basic ref="basics" :information="information"></basic>
          </el-tab-pane>
          <el-tab-pane label="科室信息" name="second">
            <department
              ref="department"
              v-if="activeName === 'second'"
              :information="information"
              @onGetList="getList"
            ></department>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
    <!-- 分类添加 -->
    <el-dialog
      :title="classTitle"
      :visible.sync="classVisible"
      width="500px"
      :before-close="closeAddEnt"
      top="270px"
    >
      <el-form
        :model="validateForm"
        ref="validateForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item
          :rules="[{ required: true, message: classPlaceholder }]"
          :label="classLable"
          prop="name"
          v-if="classVisible"
        >
          <el-input
            type="text"
            v-model.number="validateForm.name"
            :placeholder="classPlaceholder"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin:15px 50px;">
          <el-button @click="resetForm('validateForm')">取消</el-button>

          <el-button type="primary" @click="submitForm('validateForm')"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 删除弹窗 -->
    <el-dialog
      title=""
      :visible.sync="deleVisible"
      width="400px"
      class="preciseAddDialog"
      :before-close="closeAddEnt"
      top="270px"
    >
      <div class="popup-text">{{ popupText }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notEmpty, noBlank } from '@/common/utils/validate'
import { setRem } from '@/common/utils/remUnit'
import {
  listDepart,
  addOrUpdateDepart,
  delDepart,
  sortNum
} from '@/common/api/corporateInteraction/enterpriseGov'
import basic from './components/basic-information'
import department from './components/department-information'

export default {
  name: 'TagList',
  components: {
    basic,
    department
  },
  props: {},
  data() {
    return {
      tagShow: true,
      isCompontes: false,
      information: {},
      validateForm: {
        name: ''
      },
      popupText: '您确定要删除这条机关政府信息吗？',
      deleteId: '',
      deleVisible: false,
      regionForm: {
        id: '',
        name: '',
        depType: '',
        parentId: ''
      },
      classLable: '机关政府名称',
      classPlaceholder: '请输入机关政府名称',
      classTitle: '新建机关政府',
      isFrom: false,
      classVisible: false,
      visible: false,
      listLoading: false,
      name: '', // 搜索标签名
      parentId: 0, // 父级id
      yearOption: [], // 年份下拉选
      // 左侧树状图
      activeItem: {},
      activeName: 'first',
      treeData: [],
      defaultProps: {
        children: 'departList',
        label: 'name'
      },
      condition: {
        name: '',
        yearType: null,
        dataYear: '',
        entName: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      input2: '',
      tableData: [],
      // 新增编辑标签弹框
      isAdd: true,
      dialogVisible: false,
      ruleForm: {
        name: '',
        remark: '',
        isPublic: 1,
        timeDimension: 1,
        dataYear: '',
        depName: ''
      },
      rules: {
        name: [notEmpty('标签名称'), noBlank()],
        remark: [notEmpty('具体描述'), noBlank()]
      },
      // 创建文件夹弹框
      isAddFolder: false,
      folderId: '',
      addFolderVisible: false,
      addFolderForm: {},
      // 移动子文件夹弹框
      moveLabelVisible: false,
      moveLabelForm: {},
      folderList: [],
      // 删除子文件夹弹框
      delFolderVisible: false,
      delFolderForm: {},
      // 精准添加
      allEntList: [],
      preciseAddVisible: false,
      preciseAddEntList: [],
      // 模糊搜索框
      entListOptions: [],
      entListOptions1: [],
      loading: false,
      departmentOptions: [
        '国土局',
        '税务局',
        '电力局',
        '经信局',
        '科技局',
        '环保局'
      ]
      /**
       * isDirector  1 文件夹 2标签
       * type 1计算规则标签 2 原始标签 3复制标签
       */
    }
  },
  created() {
    // this.setRem()
    this.getList()
  },
  mounted() {
    // 获取标签数据
    // this.getTreeData()
    // this.getTreeData(1)
  },
  watch: {},
  methods: {
    // 拖拽成功事件
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      const obj = {
        parentId: '',
        ids: []
      }
      obj.parentId = dropNode.data.parentId
      for (const item of dropNode.parent.childNodes) {
        obj.ids.push(item.data.id)
      }
      const ids = obj.ids.length > 0 ? obj.ids.join(',') : ''
      const con = { ...obj, ids }
      // 菜单排序
      sortNum(con).then(response => {
        const res = response.data
        if (res.code == '0000') {
          this.getList()
          this.$message({
            message: res.msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    // 拖拽时判定目标节点能否被放置
    // 'prev'、'inner' 和 'next'，分前、插入、后
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        if (draggingNode.data.parentId === dropNode.data.parentId) {
          return type === 'prev' || type === 'next'
        } else {
          return false
        }
      } else {
        // 不同级进行处理
        return false
      }
    },
    // 添加机关政府
    addOffice(data) {
      this.parentId = data.id
      this.classification(0)
    },
    getList() {
      const params = {
        name: this.name,
        parentId: ''
      }

      listDepart(params).then(res => {
        const { data } = res.data
        this.treeData = data
        if (!this.information) {
          this.information = this.treeData ? this.treeData[0] : ''
        }
      })
    },
    remoteMethod() {},
    handleClick(tab, event) {},
    // 找到节点下的企业标签--找到返回的标签数据的第一个标签
    findActiveId(arr) {
      let activeItem = {}
      if (arr && arr.length > 0) {
        for (let index = 0; index < arr.length; index++) {
          const item = arr[index]
          if (item.isDirector != 1) {
            // 标签
            activeItem = { ...item }
            break
          } else if (item.children && item.children.length > 0) {
            // 文件夹
            let childItem = this.findActiveId(item.children)
            if (childItem && childItem.id) {
              activeItem = { ...childItem }
              break
            }
          }
        }
        if (activeItem && activeItem.id) {
          return activeItem
        }
      } else {
        return false
      }
    },
    // 新增或编辑
    // 表格
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {}
          if (this.regionForm.id === '') {
            params = {
              departId: '',
              name: this.validateForm.name,
              departType: this.classLable === '分类名称' ? 1 : 2,
              parentId: this.parentId
            }
          } else {
            params = {
              departId: this.regionForm.id,
              name: this.validateForm.name,
              departType: this.regionForm.depType,
              parentId: this.regionForm.parentId
            }
          }
          addOrUpdateDepart(params).then(res => {
            this.classVisible = false
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.validateForm.name = ''
            this.parentId = 0
            this.regionForm = {
              id: '',
              name: '',
              depType: '',
              parentId: ''
            }

            this.getList()
          })
        } else {
          return false
        }
      })
    },
    // 编辑
    editRegion(data) {
      const { id, name, depType, parentId } = data
      this.validateForm.name = name
      this.regionForm = {
        id,
        name,
        depType,
        parentId
      }
      this.classVisible = true
      if (depType === 2) {
        this.classTitle = '编辑机关政府'
        this.classPlaceholder = '请输入机关政府'
        this.classLable = '机关政府名称'
      } else {
        this.classTitle = '编辑区县分类'
        this.classPlaceholder = '请输入区县分类'
        this.classLable = '分类名称'
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.classVisible = false
    },
    classification(e) {
      this.classVisible = true
      if (e === 0) {
        this.classTitle = '新建机关政府'
        this.classPlaceholder = '请输入机关政府'
        this.classLable = '机关政府名称'
      } else {
        this.classTitle = '新建区县分类'
        this.classPlaceholder = '请输入区县分类'
        this.classLable = '分类名称'
      }
    },
    // 新增/编辑文件夹-弹框
    editFolderName(data) {
      if (data.id) {
        // 编辑文件夹
        let { id, name, parentId, isRepeat } = data
        this.addFolderForm = { id, parentId }
        if (!this.isAddFolder) {
          this.addFolderForm = { name, isRepeat, ...this.addFolderForm }
        }
      }
      this.addFolderVisible = true
    },
    // 新增编辑文件夹-关闭弹框
    closeAddFolder() {
      this.addFolderVisible = false
      for (let item in this.addFolderForm) {
        this.addFolderForm[item] = null
      }
    },
    // 删除文件夹-弹框
    delFolder(data) {
      this.deleteId = ''
      this.deleteId = data.id
      if (data.depType === 1) {
        if (data.departList.length === 0) {
          this.deleVisible = true
          this.popupText = '您确定要删除该区域分类吗？'
        } else {
          this.$message({
            message: '无法删除该区域分类，请先删除对应的机关政府',
            type: 'warning'
          })
        }
      } else {
        this.deleVisible = true
        this.popupText = '您确定要删除这条机关政府信息吗？'
      }
    },
    deleteSubmit() {
      delDepart({ departId: this.deleteId }).then(res => {
        this.$message({
          message: res.data.msg,
          type: 'success'
        })
        this.isCompontes = false
        this.deleVisible = false
        this.getList()
      })
    },
    // 新增编辑标签-打开弹框
    editData(row) {
      if (row.id) {
        let {
          id,
          name,
          remark,
          parentId,
          isPublic,
          timeDimension,
          depName
        } = row
        this.ruleForm = { id, parentId }
        if (!this.isAdd) {
          this.ruleForm = {
            ...this.ruleForm,
            name,
            remark,
            isPublic,
            timeDimension,
            depName
          }
        } else {
          this.ruleForm = {
            ...this.ruleForm,
            isPublic: 1,
            timeDimension: 1
          }
        }
      } else {
        this.ruleForm = {
          isPublic: 1,
          timeDimension: 1
        }
      }
      this.dialogVisible = true
    },
    // 新增编辑标签-关闭弹框
    closeLabel() {
      this.dialogVisible = false
      for (let item in this.ruleForm) {
        this.ruleForm[item] = null
      }
    },
    closeAddEnt() {
      this.preciseAddVisible = false
      this.preciseAddEntList = []
      this.entListOptions1 = []
      this.entListOptions = []
    },
    navigation(data) {
      console.log(data)
      if (data.depType === 1) {
        return
      }
      this.isCompontes = true
      this.information = data
      // this.activeName = 'first'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/styles/variables.scss';
@import '~@/common/styles/index.scss';
@import '~@/common/styles/mjCommon.scss';

$width: 262px;
.page-notbreadcrumb {
  display: flex;
  width: 100%;
  height: 100%;
  .page-list {
    width: 310px !important;
  }
  .page-prop {
    width: calc(100% - 310px);
  }
  .detail {
    height: calc(100% - 60px);
    padding: 15px 20px;
    .condition_box {
      display: flex;
      justify-content: space-between;
    }
  }
  & >>> .tag-tree {
    .is-current > .el-tree-node__content {
      background: #e0e7ff;
      .title {
        color: #4d76fd;
      }
    }
    .el-tree-node__content {
      width: 100%;
      height: 40px;
      padding-right: 3px;
      font-size: 14px;
      box-sizing: border-box;
      display: flex;
      .node-item {
        flex: 1;
        width: 0;
        // width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .subtitle {
          display: flex;
          align-items: center;
          // flex: 1;
          height: 40px;
          width: 80%;
          i {
            font-size: 14px;
            margin-right: 8px;
          }
          span {
            display: inline-block;
            width: 100%;
          }
        }
        .more {
          flex-shrink: 0;
          padding: 5px;
          .el-icon-more {
            padding: 5px 0;
          }
        }
      }
    }
  }
  & >>> .el-dialog {
    .el-dialog__header {
      padding-bottom: 20px !important;
      border-bottom: 1px solid #ebebeb;
      .header {
        display: flex;
        align-items: center;
        font-weight: 550;
      }
      .iconshuxing {
        font-size: 23px;
        color: #0091ff;
        margin-right: 5px;
      }
    }
    .el-dialog__body {
      min-height: 300px;
      padding: 40px 60px;
      box-sizing: border-box;
    }
    .el-dialog__footer {
      padding-top: 20px !important;
      border-top: 1px solid #ebebeb;
    }
  }
  & >>> .el-drawer__body {
    height: calc(100%);
  }
}
.page-headers {
  margin: 30px 0 20px 20px;
}
/deep/.el-tabs__item {
  font-size: 16px;
}
.preciseAddDialog {
  /deep/.el-dialog__body {
    padding: 40px 20px !important;
    min-height: 103px !important;
    text-align: center !important;
  }
}

.popup-text {
  margin-left: 20px;
  font-size: 16px;
}
.overFlowHid1 {
  width: 143px;
  display: inline-block;
}
</style>
